import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import {
  ShowTableCustomer,
  ShowTableCustomerPenjualanChild,
} from "../../../components/ShowTable";
import { FetchErrorHandling } from "../../../components/FetchErrorHandling";
import { SearchBar, Loader } from "../../../components";
import { Container, Form, Row, Col, Card } from "react-bootstrap";
import {
  Box,
  Pagination,
  Button,
  ButtonGroup,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useDownloadExcel } from "react-export-table-to-excel";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import PrintIcon from "@mui/icons-material/Print";
import TocIcon from "@mui/icons-material/Toc";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilCustomer = () => {
  const ref = useRef(null);
  const tableRef = useRef(null);
  const { user, dispatch, setting } = useContext(AuthContext);
  const location = useLocation();
  const id = location.pathname.split("/")[2];
  const screenSize = useScreenWidth();

  const [isFetchError, setIsFetchError] = useState(false);
  const [nopolCustomer, setNopolCustomer] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");

  const [penjualanChilds, setPenjualanChilds] = useState([]);
  const [previewPenjualanChild, setPreviewPenjualanChild] = useState(false);

  const [previewPdf, setPreviewPdf] = useState(false);
  const [previewExcel, setPreviewExcel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [customers, setCustomers] = useState([]);
  const [customersPagination, setCustomersPagination] = useState([]);
  const navigate = useNavigate();

  const [filter, setFilter] = useState("SEMUA");
  const handleChangeFilter = (event) => {
    setFilter(event.target.value);
  };

  const [loading, setLoading] = useState(false);
  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTerm(query);
  };

  useEffect(() => {
    getCustomersPagination();
    id && getCustomerById();
    ref.current?.scrollIntoView({ behavior: "smooth" });
  }, [id, page, searchTerm, filter]);

  const getCustomersPagination = async () => {
    setLoading(true);
    try {
      if (filter === "SEMUA") {
        const response = await axios.post(
          `${tempUrl}/customersPerCabangPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setCustomersPagination(response.data.customers);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
      } else if (filter === "RETAIL") {
        const response = await axios.post(
          `${tempUrl}/customersPerCabangRetailPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setCustomersPagination(response.data.customers);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
      } else if (filter === "GROSIR") {
        const response = await axios.post(
          `${tempUrl}/customersPerCabangGrosirPagination?search_query=${searchTerm}&page=${page}&limit=${limit}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setCustomersPagination(response.data.customers);
        setPage(response.data.page);
        setPages(response.data.totalPage);
        setRows(response.data.totalRows);
      }
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getCustomers = async () => {
    setLoading(true);
    try {
      const response = await axios.post(`${tempUrl}/customersPerCabang`, {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      });
      setCustomers(response.data);
    } catch (error) {
      if (error.response.status == 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      }
      setIsFetchError(true);
    }
    setLoading(false);
  };

  const getCustomerById = async () => {
    if (id) {
      const response = await axios.post(`${tempUrl}/customers/${id}`, {
        _id: user.id,
        token: user.token,
      });
      setNopolCustomer(response.data.nopolCustomer);
      setNamaCustomer(response.data.namaCustomer);
      setNoTeleponCustomer(response.data.noTeleponCustomer);

      const findPenjualanChildsByNopol = await axios.post(
        `${tempUrl}/penjualanChildsByNopol`,
        {
          nopolCustomer: response.data.nopolCustomer,
          _id: user.id,
          token: user.token,
        }
      );
      setPenjualanChilds(findPenjualanChildsByNopol.data);
    }
  };

  const downloadPdf = () => {
    var date = new Date();
    var current_date = formatDate(date);
    var current_time =
      date.getHours().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getMinutes().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      }) +
      ":" +
      date.getSeconds().toLocaleString("en-US", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      });
    const doc = new jsPDF();
    doc.setFontSize(10);
    doc.text(
      `${setting.namaPerusahaan} - ${setting.kabupatenPerusahaan}`,
      15,
      10
    );
    doc.text(`${setting.alamatPerusahaan}`, 15, 15);
    doc.setFontSize(14);
    doc.text(`Daftar Customer`, 85, 30);
    doc.setFontSize(8);
    doc.text(
      `Dicetak Oleh: ${user.username} | Tanggal : ${current_date} | Jam : ${current_time}`,
      15,
      290
    );
    doc.autoTable({
      html: "#table",
      startY: doc.pageCount > 1 ? doc.autoTableEndPosY() + 20 : 45,
      headStyles: {
        fillColor: [117, 117, 117],
        color: [0, 0, 0],
      },
      styles: {
        fontSize: 8,
      },
    });
    window.open(URL.createObjectURL(doc.output("blob")));
  };

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Customer",
    sheet: "daftarCustomer",
  });

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  if (loading) {
    return <Loader />;
  }

  if (isFetchError) {
    return <FetchErrorHandling />;
  }

  return (
    <Container ref={ref}>
      <h3>Master</h3>
      <h5 style={{ fontWeight: 400 }}>Daftar Customer</h5>

      {id && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => navigate("/customer")}
          sx={{ marginRight: 2 }}
        >
          {"< Kembali"}
        </Button>
      )}

      <Box sx={downloadButtons}>
        <ButtonGroup variant="outlined" color="secondary">
          <Button
            color="primary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getCustomers();
              setPreviewPdf(!previewPdf);
              setPreviewExcel(false);
            }}
          >
            PDF
          </Button>
          <Button
            color="secondary"
            startIcon={<SearchIcon />}
            onClick={() => {
              getCustomers();
              setPreviewExcel(!previewExcel);
              setPreviewPdf(false);
            }}
          >
            Excel
          </Button>
        </ButtonGroup>
      </Box>

      {previewPdf && (
        <div>
          <Button
            variant="outlined"
            startIcon={<PrintIcon />}
            onClick={() => downloadPdf()}
          >
            CETAK
          </Button>
          <table class="table" id="table">
            <thead>
              <tr>
                <th>Nama</th>
                <th>No. Telp</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.namaCustomer}</td>
                  <td>{user.noTeleponCustomer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div>
        {previewExcel && (
          <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={onDownload}
          >
            EXCEL
          </Button>
        )}
        <table ref={tableRef}>
          {previewExcel && (
            <tbody>
              <tr>
                <th>Nama</th>
                <th>No. Telp</th>
              </tr>
              {customers.map((user, index) => (
                <tr key={user.id}>
                  <td>{user.namaCustomer}</td>
                  <td>{user.noTeleponCustomer}</td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>

      <Row>
        <FormControl sx={{ marginTop: 1 }}>
          <FormLabel id="demo-controlled-radio-buttons-group">Filter</FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-controlled-radio-buttons-group"
            name="controlled-radio-buttons-group"
            defaultValue="SEMUA"
            value={filter}
            onChange={handleChangeFilter}
          >
            <FormControlLabel value="SEMUA" control={<Radio />} label="Semua" />
            <FormControlLabel
              value="RETAIL"
              control={<Radio />}
              label="Retail"
            />
            <FormControlLabel
              value="GROSIR"
              control={<Radio />}
              label="Grosir"
            />
          </RadioGroup>
        </FormControl>
      </Row>

      {id && (
        <Box sx={downloadButtons}>
          <ButtonGroup variant="outlined" color="secondary">
            <Button
              color="primary"
              startIcon={<TocIcon />}
              onClick={() => {
                setPreviewPdf(false);
                setPreviewExcel(false);
                setPreviewPenjualanChild(!previewPenjualanChild);
              }}
            >
              History
            </Button>
          </ButtonGroup>
        </Box>
      )}

      {previewPenjualanChild && (
        <Box sx={tableContainer}>
          <ShowTableCustomerPenjualanChild currentPosts={penjualanChilds} />
        </Box>
      )}

      <Box sx={buttonModifierContainer}>
        {id && (
          <ButtonGroup variant="contained">
            <Button
              color="primary"
              startIcon={<EditIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => {
                navigate(`/customer/${id}/edit`);
              }}
            >
              Ubah
            </Button>
          </ButtonGroup>
        )}
      </Box>
      {id && (
        <Container>
          <hr />
          <Form>
            {/* Customer */}
            <Card>
              <Card.Header>Customer</Card.Header>
              <Card.Body>
                <Box sx={textFieldContainer}>
                  <Box sx={textFieldWrapper}>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Polisi :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={nopolCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            Nama :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={namaCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Form.Group
                          as={Row}
                          className="mb-3"
                          controlId="formPlaintextPassword"
                        >
                          <Form.Label column sm="5" style={textRight}>
                            No. Telp / HP :
                          </Form.Label>
                          <Col sm="7">
                            <Form.Control
                              value={noTeleponCustomer}
                              disabled
                              readOnly
                            />
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Box>
                  <Box sx={[textFieldWrapper, secondWrapper]}></Box>
                </Box>
              </Card.Body>
            </Card>
          </Form>
        </Container>
      )}
      <hr />
      <Form onSubmit={searchData}>
        <Box sx={searchBarContainer}>
          <SearchBar value={query} setSearchTerm={setQuery} />
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disableElevation
          >
            Cari
          </Button>
        </Box>
      </Form>
      <Box sx={tableContainer}>
        <ShowTableCustomer currentPosts={customersPagination} />
      </Box>
      <Box sx={tableContainer}>
        <Pagination
          count={pages}
          page={page + 1}
          onChange={handleChange}
          color="primary"
          size={screenSize <= 600 ? "small" : "large"}
        />
      </Box>
    </Container>
  );
};

export default TampilCustomer;

const buttonModifierContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const downloadButtons = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};
